import { render } from "./Tooltip.vue?vue&type=template&id=1ff64538"
import script from "./Tooltip.vue?vue&type=script&lang=js"
export * from "./Tooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__